import { render, staticRenderFns } from "./SelfLearningCourseView.vue?vue&type=template&id=d978b1d0"
import script from "./SelfLearningCourseView.vue?vue&type=script&lang=js"
export * from "./SelfLearningCourseView.vue?vue&type=script&lang=js"
import style0 from "./SelfLearningCourseView.vue?vue&type=style&index=0&id=d978b1d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports